import moment from 'moment';

// Common date formatting functions using moment.js
export const formatters = {
  // Full date with time (e.g., "December 24, 2024 at 15:30")
  fullDateTime: (date) => {
    if (!date) return null;
    return moment(date).format('MMMM DD, YYYY [at] HH:mm');
  },

  // Short date with time (e.g., "Dec 24, 2024 at 15:30")
  shortDateTime: (date) => {
    if (!date) return null;
    return moment(date).format('MMM DD, YYYY [at] HH:mm');
  },

  // Date only (e.g., "December 24, 2024")
  dateOnly: (date) => {
    if (!date) return null;
    return moment(date).format('MMMM DD, YYYY');
  },

  // Time only (e.g., "15:30")
  timeOnly: (date) => {
    if (!date) return null;
    return moment(date).format('HH:mm');
  },

  // Relative time (e.g., "2 hours ago", "in 3 days")
  relative: (date) => {
    if (!date) return null;
    return moment(date).fromNow();
  },

  // Year only (e.g., "2024")
  yearOnly: (date) => {
    if (!date) return null;
    return moment(date).format('YYYY');
  },

  // Current year
  currentYear: () => moment().format('YYYY')
};

// Utility functions
export const dateUtils = {
  // Check if date is today
  isToday: (date) => {
    if (!date) return false;
    return moment(date).isSame(moment(), 'day');
  },

  // Check if date is in the past
  isPast: (date) => {
    if (!date) return false;
    return moment(date).isBefore(moment());
  },

  // Check if date is in the future
  isFuture: (date) => {
    if (!date) return false;
    return moment(date).isAfter(moment());
  },

  // Get difference between dates
  diff: (date1, date2, unit = 'days') => {
    if (!date1 || !date2) return null;
    return moment(date1).diff(moment(date2), unit);
  },

  // Add time to a date
  add: (date, amount, unit) => {
    if (!date) return null;
    return moment(date).add(amount, unit);
  },

  // Subtract time from a date
  subtract: (date, amount, unit) => {
    if (!date) return null;
    return moment(date).subtract(amount, unit);
  }
}; 